import { createDataProvider } from './helpers';
import { ScriptsService, StatusService, MetaService, ExitWizardService } from './services';

export const provideSharedCoreData = createDataProvider(ScriptsService, StatusService, MetaService, ExitWizardService);
